<template>
    <div class="viewContainer winesView">
        <p class="smallText">
            <AnimatedNumber :number="frontendFilteredWinePositionsLength" /> {{ $t('general.positions') }} (
            <AnimatedNumber :number="animatedNumberWinesAmountFloat" /> {{ $tc('general.bottle', 2) }} )
        </p>
        <div class="spacer xs" />
        <div class="winesViewHeader">
            <div class="winesViewHeaderLeftContainer">
                <div class="winesViewHeaderColumn">
                    <div>
                        <h1 class="">{{ renderTitle(getCurrentListTitle) }}</h1>
                        <b-dropdown v-if="selectedView != 'graph'" size="lg" toggle-class="text-decoration-none"
                            class="m-2 actionsMenu" no-caret>
                            <template #button-content>
                                <b-icon icon="three-dots-vertical"></b-icon>
                            </template>
                            <b-dropdown-item-button
                                v-if="playlistId != null || (smartListId != null && getCurrentListTitle !== 'Favoriten')"
                                class="edit" @click="showEditPlaySmartListModal()">{{
                $t('winelist.editList') }}</b-dropdown-item-button>
                            <b-dropdown-item-button
                                v-if="playlistId != null || (smartListId != null && getCurrentListTitle !== 'Favoriten')"
                                class="delete" @click="showDeletePlaySmartList = true">{{
                $t('winelist.deleteList') }}</b-dropdown-item-button>

                            <ExportCSVButton :venueWines="frontendFilteredWines" :venueTitle="getVenue.attributes.title" :listTitle="getCurrentListTitle" />
														<PrintButton />
                        </b-dropdown>
                    </div>
                </div>
                <div class="winesViewHeaderColumn">
                    <b-button-group :class="'toggleButtons selectWineView ' + selectedView">
                        <b-button @click="selectedView = 'list'">
                            <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M5 11.5h2v-2H5v2zm0 4h2v-2H5v2zm0-8h2v-2H5v2zm4 4h10v-2H9v2zm0 4h10v-2H9v2zm0-10v2h10v-2H9zm-4 6h2v-2H5v2zm0 4h2v-2H5v2zm0-8h2v-2H5v2zm4 4h10v-2H9v2zm0 4h10v-2H9v2zm0-10v2h10v-2H9zm-4 14h2v-2H5v2zm4-2v2h10v-2H9z"
                                    fill="#0CBA4A" fill-rule="nonzero" />
                            </svg>
                        </b-button>
                        <b-button @click="selectedView = 'graph'">
                            <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11 9.66V2.5c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84 0-1.32 1-2.43 2-2.84zm3.86 1.84H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 15.34v7.16c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z"
                                    fill="#0CBA4A" fill-rule="nonzero" />
                            </svg>
                        </b-button>
                    </b-button-group>
                </div>
                <div v-if="selectedView == 'list' && getUser.searchHistory != null"
                    class="searchOuterContainer winesViewHeaderColumn">
                    <SearchDataList :searchFromOutside="search.text" :autoSuggestComplete="getAutoSuggestOptions()"
                        :isLastSearch="true" :itemClickedFunction="loadWinesWithSearch" />
                </div>
                <div v-if="selectedView == 'list'" class="winesViewHeaderColumn">
                    <b-button-group class="toggleButtons wineViewFilter">
                        <b-button @click="wineFilter = 'vorraetig'" :class="wineFilter == 'vorraetig' ? 'active' : ''">{{
                $t('winelist.filterAvailable') }}</b-button>
                        <b-button @click="wineFilter = 'offen'" :class="wineFilter == 'offen' ? 'active' : ''">{{
                $t('winelist.filterOpenWines') }}</b-button>
                        <b-button @click="wineFilter = 'ausgetrunken'" :class="wineFilter == 'ausgetrunken' ? 'active' : ''"><span>{{
                $t('winelist.filterDrunk') }} ({{
                winesWithNoamountLength }})</span></b-button>
                        <b-button
                            v-if="playlistId == null && smartListId == null && selectedView == 'list' && winesWithMissingAttributsLength > 0"
                            class="missingAttributes" @click="wineFilter = 'missingAttributes'"
                            :class="wineFilter == 'missingAttributes' ? 'active' : ''"><span>{{
                $t('winelist.filterMissingAttributes') }} ({{
                winesWithMissingAttributsLength }})</span></b-button>
                    </b-button-group>
                </div>
                <div class="winesViewHeaderColumn" v-if="selectedView == 'graph'">
                    <b-button-group class="toggleButtons wineViewFilter">
                        <b-button @click="wineChartFilter = 'land'" :class="wineChartFilter == 'land' ? 'active' : ''">{{
                $t('general.country') }}</b-button>
                        <b-button @click="wineChartFilter = 'region'" :class="wineChartFilter == 'region' ? 'active' : ''">{{
                $t('general.region') }}</b-button>
                        <b-button @click="wineChartFilter = 'grapeVariety'"
                            :class="wineChartFilter == 'grapeVariety' ? 'active' : ''">{{
                $t('general.grapeVariety') }}</b-button>
                        <b-button @click="wineChartFilter = 'wineType'"
                            :class="wineChartFilter == 'wineType' ? 'active' : ''">{{
                $t('general.winetype') }}</b-button>
                    </b-button-group>
                </div>
            </div>
            <div class="winesViewHeaderColumn datePicker" v-if="selectedView == 'graph'">
                <DatePicker @date-selected="onDateSelected" />
            </div>
        </div>
        <div class="winesViewButtons">
            <div class="addWine" v-if="playlistId == null && smartListId == null && selectedView == 'list'">
                <button id="addNewWine" @click="addWine()" class="iconButton add">{{ $t('winelist.addWine') }}</button>
            </div>
        </div>
        <div class="winelistContainer noResults" v-if="frontendFilteredWinesLength === 0 && loading === false">
            <svg width="82" height="154" viewBox="0 0 82 154" xmlns="http://www.w3.org/2000/svg">
                <g fill="#000" fill-rule="nonzero">
                    <path
                        d="M36.996 87.614c0 19.647-.001 39.226.002 58.806 0 1.828-.802 3.164-2.25 4.259-1.422 1.074-3.041 1.667-4.68 2.194-1.082.348-2.283.306-3.389.6-1.57.417-3.169.243-4.741.417-2.037.225-4.06.024-6.089.087-1.166.036-2.34-.037-3.505-.133-.846-.07-1.686-.237-2.522-.398-1.054-.204-2.127-.362-3.144-.69-1.565-.506-3.094-1.085-4.445-2.116-1.384-1.056-2.095-2.41-2.188-4.087-.059-1.08.09-2.17.106-3.255.008-.476-.118-.954-.12-1.43-.01-4.327-.005-8.653-.005-12.979V67.778c0-2.148-.07-4.3.02-6.444.085-2.025.223-4.061.553-6.057.282-1.71.691-3.446 1.369-5.03.655-1.534 1.674-2.923 2.624-4.312 1.084-1.583 2.663-2.613 4.306-3.532.433-.242.887-.5 1.362-.596.61-.122.665-.455.664-.976-.013-7.953-.009-15.907-.009-23.86v-5.16c0-.617.004-1.233-.001-1.849-.005-.498.102-1.011-.388-1.404-.138-.112-.14-.44-.142-.67-.014-1.059-.007-2.118-.005-3.177 0-.154-.032-.33.028-.46.473-1.02.883-2.084 1.475-3.03C12.355.463 13.118 0 14.096.005c2.734.017 5.468.04 8.2-.006 2.002-.032 3.139.815 3.567 2.633.182.774.795 1.32.785 2.122-.015 1.156-.003 2.313-.007 3.47 0 .058-.028.14-.07.17-.76.52-.597 1.311-.598 2.05-.001 9.847.02 19.693-.03 29.539-.006 1.12.286 1.806 1.345 2.106 1.25.355 2.287 1.083 3.238 1.923 2.029 1.79 3.71 3.847 4.584 6.467.462 1.387.92 2.777 1.297 4.188.167.623.123 1.302.187 1.954.13 1.318.38 2.636.384 3.955.034 8.99.018 17.98.018 27.037zM72.745 151.185c1.373.134 2.697.18 3.98.435.84.167 1.767.174 2.49.759.103.083.144.242.214.366-.13.063-.256.14-.392.186-1.607.549-3.283.678-4.957.806a46.15 46.15 0 0 1-2.556.134c-2.682.056-5.365.124-8.048.129-2.057.004-4.118-.028-6.171-.146-1.138-.065-2.26-.395-3.398-.495-.646-.057-1.274-.074-1.845-.415-.198-.119-.389-.252-.583-.379.208-.191.395-.517.626-.551 1.482-.222 2.973-.393 4.463-.557 1.371-.15 2.776-.146 4.106-.463.614-.146 1.183-.825 1.601-1.39.675-.913.988-1.96.98-3.157-.043-6.642-.05-13.285.002-19.926.012-1.454-.763-2.277-1.779-3.044-1.175-.886-2.398-1.72-3.506-2.686-1.845-1.607-3.413-3.474-4.74-5.54a22.383 22.383 0 0 1-2.443-5.101c-.501-1.523-.969-3.063-1.321-4.625a18.293 18.293 0 0 1-.414-3.456c-.064-2.105-.082-4.216.005-6.32.054-1.32.33-2.632.514-3.947.127-.909.22-1.826.413-2.721.224-1.04.52-2.066.823-3.085.486-1.634.983-3.265 1.52-4.883.279-.843.662-1.651.981-2.482.184-.479.546-.615 1.01-.614 1.854.003 3.707.001 5.56.001 5.49 0 10.982.016 16.474-.018.737-.004 1.086.38 1.335.92.267.58.439 1.207.642 1.817.419 1.26.855 2.516 1.24 3.787.442 1.465.916 2.917 1.102 4.458.143 1.181.521 2.333.773 3.503.082.376.117.767.136 1.153.056 1.169.073 2.34.147 3.507.034.55.173 1.094.244 1.643.03.241.037.492.01.734-.124 1.156-.255 2.31-.4 3.464-.135 1.084-.202 2.186-.456 3.242-.404 1.68-.802 3.384-1.454 4.973-.66 1.608-1.56 3.13-2.472 4.617-1.17 1.91-2.685 3.565-4.357 5.038-1.245 1.097-2.658 2-3.96 3.034-.871.692-1.471 1.638-1.478 2.752-.039 6.545-.056 13.09.005 19.635.017 1.891.939 3.485 2.466 4.587.46.332 1.233.24 1.866.315.308.036.623.006 1.002.006z" />
                </g>
            </svg>
            <p v-if="hasPlaylist == false && hasSmartlist == false"><span class="emptyState">{{
                $t('winelist.noResults') }}</span></p>
            <p v-if="hasPlaylist == true || hasSmartlist == true"><span class="emptyState">{{
                $t('winelist.noWinesStored') }}</span></p>
        </div>

        <div class="winelistContainer noResults" v-if="frontendFilteredWinesLength === 0 && loading === true">
            <LoadingAnimation />
        </div>

        <div class="winelistContainer" v-if="frontendFilteredWinesLength > 0 && selectedView == 'list'">
            <b-table id="my-table" ref="venueWineList" select-mode="single" :per-page="venueWinesPerPage"
                :current-page="currentPage" :items="frontendFilteredWines" :fields="fields" sticky-header
                @row-clicked="(item) => showWineDetails(item)" v-on:scroll.native="onWineListTableScroll()">
                <!-- A custom formatted column -->
                <template #cell(id)="data">
                    <Container willAcceptDrop=false group-name="playlistDrop" drag-class="opacity-ghost">
                        <Draggable class="moveWineButton" key:="data.value">
                            <div :id="data.value"><span>{{ $t('winelist.dragOnList') }}</span></div>
                        </Draggable>
                    </Container>
                </template>
                <!-- A custom formatted column -->
                <template #cell(attributes.year)="data">
                    <span v-if="data.value === 0 || !data.value">{{ $t('general.notDefined') }}</span>
                    <span v-else>{{ data.value }}</span>
                </template>

                <!-- A custom formatted column -->
                <template #cell(attributes.purchasePriceAvg)="data">
                   {{ data.value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </template>
                <!-- A custom formatted column -->
                <template #cell(attributes.sellingPrice)="data">
                   {{ data.value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </template>
                <template #cell(attributes.wine.data.attributes.land.data.attributes.localeKey)="data">
                    {{ $t('countries.' + data.value) }}
                </template>
                <template #cell(attributes.wine.data.attributes.wineType.data.attributes.localeKey)="data">
                    {{ $t('wineTypes.' + data.value) }}
                </template>
                <template #cell(attributes.wine.data.attributes.region.data.attributes.localeKey)="data">
                    <span v-if="data.value">{{ $t('regions.' + data.value) }}</span>
                    <span v-else>{{ data.item.attributes.wine.data.attributes.region.data.attributes.title }}</span>
                </template>
                <template #cell(weq)="data">
                    <Weq :purchasePriceAvg="data.item.attributes.purchasePriceAvg"
                        :sellingPrice="data.item.attributes.sellingPrice" />
                </template>

            </b-table>
            <b-pagination v-if="amountRows > venueWinesPerPage" v-model="currentPage" :total-rows="amountRows"
                :per-page="venueWinesPerPage" aria-controls="my-table" limit="4" align="right" prev-text="" next-text=""
                first-text="" last-text="" hide-ellipsis></b-pagination>
        </div>

        <div v-if="wines.data != null && wines.data.length > 0 && selectedView == 'graph'">
            <Chart :wineChartData="{ filter: wineChartFilter, wines: wines.data }" :currency="getCurrency"
                :type="wineChartFilter" :selectedDate="selectedDate" />
        </div>

        <WineDetailOverlay ref="wineDetailOverlay" v-model="selectedWine" :detailsClass="detailsClass"
            :closePressed="closeWineDetails" :reloadWinesList="reloadThisWineList" />

        <b-modal size="md" v-model="showDeletePlaySmartList">
            <div class="row">
                <b-col cols="2">
                    <svg width="47" height="44" viewBox="0 0 47 44" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fill-rule="evenodd">
                            <path
                                d="M22.152 3.102a5 5 0 0 1 5.706 2.364L44.14 34.412a4.984 4.984 0 0 1 .457 3.8 5 5 0 0 1-4.815 3.652H7.218c-1.381 0-2.631-.56-3.536-1.465a5 5 0 0 1-.822-5.987L19.142 5.466a4.984 4.984 0 0 1 3.01-2.364z"
                                stroke="#0CBA4A" stroke-width="2.727" stroke-linejoin="round" />
                            <text font-family="Roboto-Bold, Roboto" font-size="21.818" font-weight="bold" fill="#0CBA4A"
                                transform="translate(1 .5)">
                                <tspan x="19.664" y="33.636">!</tspan>
                            </text>
                        </g>
                    </svg>
                </b-col>
                <b-col>
                    <h2 v-if="playlistId != null">{{ $t('winelist.deleteModal.title')}}</h2>
                    <h2 v-if="smartListId != null">{{ $t('winelist.deleteModal.titleSmartlist')}}</h2>
                    <p>
                        <i18n path="winelist.deleteModal.text">
                            <template v-slot:listtitle>
                                <strong>{{getCurrentListTitle}}</strong>
                            </template>
                        </i18n>
                    </p>
                </b-col>
            </div>
            <template class="poolinqModalFooter" #modal-footer="{ cancel }">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="sm" @click="cancel">
                    {{ $t('general.buttons.cancel')}}
                </b-button>
                <b-button size="sm" variant="success" @click="deletePlaySmartList()">
                    {{ $t('general.buttons.delete')}}
                </b-button>
            </template>
        </b-modal>

        <CreateWinesModal ref="createWinesModal" @addedNewVenueWines="handleAddedNewVenueWines"/>

        <PlaySmartListEditModal ref="playSmartListEditModal" />

    </div>
</template>
<script>
import DataService from '@/services/StrapiService'
import { mapGetters } from 'vuex'
import { Container, Draggable } from "vue-dndrop"
import Chart from '@/components/charts/Chart.vue'
import LoadingAnimation from '@/components/LoadingAnimation.vue'
import AnimatedNumber from '@/components/AnimatedNumber.vue'
import CreateWinesModal from '@/components/modals/addWine/CreateWinesModal.vue'
import PlaySmartListEditModal from '@/components/modals/PlaySmartListEditModal.vue'
import SearchDataList from '@/components/SearchDataList.vue'
import WineDetailOverlay from '@/components/WineDetailOverlay.vue'
import DatePicker from '../components/datePicker.vue'
import PrintButton from '@/components/buttons/PrintButton.vue';
import Weq from '../components/wineDetail/Weq.vue'
import ExportCSVButton from '@/components/buttons/ExportCSVButton.vue'

export default {
    components: { Container, Draggable, Chart, AnimatedNumber, CreateWinesModal, PlaySmartListEditModal, LoadingAnimation, SearchDataList, WineDetailOverlay, DatePicker, PrintButton, Weq, ExportCSVButton },
    async created() {
        if (this.playlistId == null && this.smartListId == null) {
            this.$store.commit('updateFilter', {})
        }
        this.loadWines()
    },
    props: {
        playlistId: String,
        smartListId: String,
    },
    data() {
        return {
            title: this.$t('winelist.title'),
            venues: [],
            wines: [],
            wineListScrollTop: 0,
            search: { text: '', value: '' },
            loading: true,
            detailsClass: "",
            selectedWine: {},
            selectedView: 'list',
            showDeletePlaySmartList: false,
            wineFilter: '',
            wineChartFilter: 'land',
            selectedDate: null,
            venueWinesPerPage: 200,
            currentPage: 1,
        }
    },
    methods: {
        async loadWines() {
            this.loading = true
            this.wines = []
            if (this.getFilter != null && (Object.keys(this.getFilter).length > 0)) {
                if ('playlist' in this.getFilter) {
                    await DataService.getPlaylistWithFilter(this.getFilter.playlist, this.search.text).then((response) => {
                        this.wines = response['data'].data.attributes.venueWines
                        this.$store.commit('updateCurrentListTitle', response['data'].data.attributes.title)
                        this.loading = false
                        if (this.search != null && this.search.text.length > 0) {
                            this.updateUserSearchHistory(this.search)
                        }
                    }).catch((err) => {
                        // handle error
                        this.loading = false
                        console.log(err)
                    })
                } else if ('smartList' in this.getFilter) {
                    await DataService.getSmartList(this.getFilter.smartList).then((smartListResponse) => {

                        const smartListTitle = smartListResponse['data'].data.attributes.title
                        const smartListFilterQuery = smartListResponse['data'].data.attributes.filterQuery

                        DataService.findVenueWinesWithSmartListFilter(smartListFilterQuery, this.search.text).then((response) => {

                            this.wines = response['data']
                            this.$store.commit('updateCurrentListTitle', smartListTitle)
                            if (this.search != null && this.search.text.length > 0) {
                                this.updateUserSearchHistory(this.search)
                            }
                            this.loading = false
                        }).catch((err) => {
                            this.loading = false
                            console.log(err)
                        })

                    }).catch((err) => {
                        this.loading = false
                        console.log(err)
                    })
                }
            } else {
                await DataService.getVenueWines().then((response) => {
                    this.wines = response['data']
                    this.$store.commit('updateCurrentListTitle', this.$t('winelist.title'))
                    if (this.search != null && this.search.text.length > 0) {
                        this.updateUserSearchHistory(this.search)
                    }
                    this.loading = false
                }).catch((err) => {
                    // handle error
                    this.loading = false
                    console.log(err)
                })
            }
            this.restoreWineListScrollPosition();
            this.wineFilter = 'vorraetig';
        },
        reloadThisWineList() {
            // this.search = { text: '', value: '' }
            this.loadWines()
        },
        onDateSelected(date) {
            date = new Date(date);
            this.selectedDate = date.toISOString();
        },
        renderTitle(title) {
            if (title === 'Favoriten') {
                return this.$t('navigation.smartListFavorites')
            } else {
                return title
            }
        },
        showWineDetails(venuewine) {
            this.selectedWine = venuewine
            this.detailsClass = "active"
        },

        closeWineDetails(amountFloat, amountFloatBefore) {
            this.detailsClass = ""
            this.$refs.venueWineList.clearSelected()
            if (amountFloat !== amountFloatBefore) {
                this.selectedWine.attributes.amountFloat = amountFloatBefore
            }
        },
        loadWinesWithSearch(searchText) {
            if (typeof searchText === "string") {
                this.search = { text: searchText, value: searchText }
            } else {
                this.search = { text: searchText.text, value: searchText.value }
            }
            // Auskommentiert, weil Umstellung auf Frontend-Suche
            /*
            this.loadWines()
            */
        },
        addWine() {
            this.$refs.createWinesModal.showModal();
        },
    handleAddedNewVenueWines() {
        this.loadWines(true)
    },
    deletePlaySmartList() {
        if (this.playlistId != null) {
            DataService.deletePlaylist(this.playlistId).then(() => {

                DataService.getVenueDetail(this.getVenue.id).then((response) => {
                    this.showDeletePlaySmartList = false
                    this.$store.commit('updateVenue', response['data'].data)
                    this.$router.push('/')
                }).catch((err) => {
                    console.log(err)
                })

            }).catch((err) => {
                // handle error
                console.log(err)
            })
        } else if (this.smartListId != null) {
            DataService.deleteSmartList(this.smartListId).then(() => {

                DataService.getVenueDetail(this.getVenue.id).then((response) => {
                    this.showDeletePlaySmartList = false
                    this.$store.commit('updateVenue', response['data'].data)
                    this.$router.push('/')
                }).catch((err) => {
                    console.log(err)
                })

            }).catch((err) => {
                // handle error
                console.log(err)
            })
        }
    },
    showEditPlaySmartListModal() {
        if (this.playlistId != null) {
            this.$refs.playSmartListEditModal.showModal(this.playlistId, false)
        } else if (this.smartListId != null) {
            this.$refs.playSmartListEditModal.showModal(this.smartListId, true)
        }
    },
    updateUserSearchHistory(search) {
        if (this.wines.data.length > 0) {
            var user = this.getUser

            if (user.searchHistory == null) {
                user.searchHistory = []
            }
            if (user.searchHistory.indexOf(search.text) == -1) {
                user.searchHistory.push(search.text)
                DataService.updateUserData(user).then((response) => {
                    this.$store.commit('updateUserData', response.data)
                }).catch((err) => {
                    console.log(err)
                })
            }
        }
    },
    //store wine list scroll position
    onWineListTableScroll() {
        if (this.$refs.venueWineList) {
            const element = this.$refs.venueWineList.$el
            this.wineListScrollTop = element.scrollTop
        }
    },
    //keep scroll position after wine list reload
    restoreWineListScrollPosition() {
        if (this.$refs.venueWineList) {
            const element = this.$refs.venueWineList.$el
            element.scrollTop = this.wineListScrollTop
        }
    },
    getAutoSuggestOptions() {
        if (this.getUser != null && this.getUser.searchHistory) {
            const searchHistoryList = this.getUser.searchHistory.reverse()
            const options = searchHistoryList.map((searchHistory) => { return { text: searchHistory, value: searchHistory } })
            return options
        }
    },
    winesWithNoamount(wines) {
        return (wines ?? []).filter(this.checkIfIncludesSearchTerm).filter(venueWine => venueWine.attributes.amountFloat == 0 )
    },
    winesWithMissingAttributes(wines) {
        return (wines ?? []).filter(this.checkIfIncludesSearchTerm).filter(venueWine => venueWine.attributes.purchasePriceAvg == null || venueWine.attributes.sellingPrice == 0 || venueWine.attributes.sellingPrice == null || (venueWine.attributes.glassMode == true && (venueWine.attributes.glassPrice == null || venueWine.attributes.glassPrice == 0)))
    },
    filterBySearchTerm(filteredWines) {
        filteredWines = (filteredWines ?? []).filter(this.checkIfIncludesSearchTerm)
        return filteredWines
    },
    normalizeString(normalizeToString) {
        var normalizedString = normalizeToString.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
        return normalizedString
    },
    checkIfIncludesSearchTerm(venueWine) {

        var thisFilterText = this.normalizeString(this.search.text)
        var shouldBeShown = false
        if (venueWine.attributes.title) {
            if (this.normalizeString(venueWine.attributes.title).includes(thisFilterText)) {
                shouldBeShown = true
            }
        }
        if (venueWine.attributes.comments) {
            if (this.normalizeString(venueWine.attributes.comments).includes(thisFilterText)) {
                shouldBeShown = true
            }
        }
        if (venueWine.attributes.articleNumber) {
            if (this.normalizeString(venueWine.attributes.articleNumber).includes(thisFilterText)) {
                shouldBeShown = true
            }
        }
        if (venueWine.attributes.shelfNumber) {
            if (this.normalizeString(venueWine.attributes.shelfNumber).includes(thisFilterText)) {
                shouldBeShown = true
            }
        }
        if (venueWine.attributes.wine.data) {
            if (venueWine.attributes.wine.data.attributes.winery.data) {
                if (this.normalizeString(venueWine.attributes.wine.data.attributes.winery.data.attributes.title).includes(thisFilterText)) {
                    shouldBeShown = true
                }
            }
            if (venueWine.attributes.wine.data.attributes.region.data) {
                if (this.normalizeString(venueWine.attributes.wine.data.attributes.region.data.attributes.title).includes(thisFilterText)) {
                    shouldBeShown = true
                }
            }
            if (venueWine.attributes.wine.data.attributes.grapeVariety) {
                if (this.normalizeString(venueWine.attributes.wine.data.attributes.grapeVariety.data.attributes.title).includes(thisFilterText)) {
                    shouldBeShown = true
                }
            }
            if (venueWine.attributes.wine.data.attributes.land.data) {
                if (this.normalizeString(venueWine.attributes.wine.data.attributes.land.data.attributes.title).includes(thisFilterText)) {
                    shouldBeShown = true
                }
            }
            if (venueWine.attributes.wine.data.attributes.wineType.data) {
                if (this.normalizeString(venueWine.attributes.wine.data.attributes.wineType.data.attributes.title).includes(thisFilterText)) {
                    shouldBeShown = true
                }
            }
        }
        if (venueWine.attributes.year) {
            if (venueWine.attributes.year.toString().includes(thisFilterText)) {
                shouldBeShown = true
            }
        }

        if (shouldBeShown === true) {
            return venueWine
        }
    }
},
computed: {
    amountRows() {
        return this.frontendFilteredWines.length
    },
		animatedNumberWinesAmountFloat() {
				const filteredWines = this.frontendFilteredWines ?? []
				const winesAmountFloat = filteredWines.reduce((acc, item) => {
					const amount = parseFloat(item.attributes.amountFloat)
					return acc + amount
				}, 0);
				return Math.round(winesAmountFloat)
		},
		/**
		 * Filtered wines according to the current wine filter mode
		 * this array is displayed in the wine list table
		 */
    frontendFilteredWines() {
        console.log("frontendFilteredWines called")
        var filteredWines = [];
        switch (this.wineFilter) {
            case 'vorraetig':
                filteredWines = (this.wines.data ?? []).filter(venueWine => venueWine.attributes.amountFloat > 0)
                break
            case 'offen':
                filteredWines = (this.wines.data ?? []).filter(venueWine => venueWine.attributes.glassMode == true)
                break
            case 'ausgetrunken':
                filteredWines = (this.wines.data ?? []).filter(venueWine => venueWine.attributes.amountFloat == 0)
                break
            case 'missingAttributes':
                // Hier werden alle Weine dargestellt, die entweder keinen EK oder VK haben oder keinen VK pro Glas, wenn Glas-Mode gleich true ist 
                filteredWines = this.winesWithMissingAttributes(this.wines.data)
                break
            default:
                filteredWines = this.wines.data ?? []
        }
        // Neu: Frontend Filter
        if (this.search.text && this.search.text !== "") {
            filteredWines = this.filterBySearchTerm(filteredWines)
        }
        return filteredWines;
    },
    frontendFilteredWinesLength() {
        return (this.frontendFilteredWines ?? []).length
    },
    /**
     * Shown in Header as animated number to display the amountFloat of wines in the list
     * according to the current wine filter mode
     */
    frontendFilteredWinePositionsLength() {
        let positions = this.frontendFilteredWines ?? []
        if (this.wineFilter !== 'ausgetrunken') {
            return positions.filter(venueWine => venueWine.attributes.amountFloat > 0).length
        }
        return positions.length
    },
    winesWithNoamountLength() {
        return this.winesWithNoamount(this.wines.data).length
    },
    winesWithMissingAttributsLength() {
        return this.winesWithMissingAttributes(this.wines.data).length
    },
    hasPlaylist: function () {
        return this.getFilter.playlist != null
    },
    hasSmartlist: function () {
        return this.getFilter.smartList != null
    },
    isFavoriteSmartList() {
        if ('smartList' in this.getFilter) {
            return this.getFilter.smartList.type === "favorite"
        }
        return false
    },
    getCurrency() {
        return (this.getVenue.attributes.currency != null) ? this.getVenue.attributes.currency.data.attributes.symbol : '€'
    },
    fields() {
        return [
            'id',
            {
                key: 'id',
                label: 'ID',
                sortable: false
            },
            {
                key: 'attributes.wine.data.attributes.winery.data.attributes.title',
                label: this.$t('general.winery'),
                sortable: true
            },
            {
                key: 'attributes.title',
                label: this.$t('general.winetitle'),
                sortable: true
            },
            {
                key: 'attributes.wine.data.attributes.wineType.data.attributes.localeKey',
                label: this.$t('general.color'),
                sortable: true
            },
            {
                key: 'attributes.bottleSize.data.attributes.amount',
                label: this.$t('general.bottleSize_short'),
                sortable: true
            },
            {
                key: 'attributes.year',
                label: this.$t('general.vintage_short'),
                sortable: true
            },
            {
                key: 'attributes.amountFloat',
                label: this.$t('general.amount'),
                sortable: true
            },
            {
                key: 'attributes.wine.data.attributes.region.data.attributes.localeKey',
                label: this.$t('general.region'),
                sortable: true
            },
            {
                key: 'attributes.wine.data.attributes.land.data.attributes.localeKey',
                label: this.$t('general.country'),
                sortable: true
            },
            {
                key: 'attributes.purchasePriceAvg',
                label: this.$t('general.ek_short') + ' ' + this.getCurrency,
                sortable: true
            },
            {
                key: 'attributes.sellingPrice',
                label: this.$t('general.vk_short') + ' ' + this.getCurrency,
                sortable: true
            },
            {
                key: 'weq',
                label: this.$t('general.weq'),
                sortable: false
            },

        ]
    },
            ...mapGetters(['getUser', 'getVenue', 'getFilter', 'getCurrentListTitle',
        'getReloadWines', 'getBottleSizes', 'getClickedOutside'])
},
mounted() { },
watch: {
    playlistId(newValue) {
        this.search = { text: '', value: '' }
        if (newValue != null) {
            var filter = { playlist: newValue }
            this.$store.commit('updateFilter', filter)
            this.$store.commit('updateCurrentListTitle', "")
            this.loadWines()
        } else if (this.smartListId == null) {
            this.$store.commit('updateFilter', {})
            this.$store.commit('updateCurrentListTitle', this.$t('winelist.title'))
            this.loadWines()
        }
    },
    smartListId(newValue) {
        this.search = { text: '', value: '' }
        if (newValue != null) {
            var filter = { smartList: newValue }
            this.$store.commit('updateFilter', filter)
            this.$store.commit('updateCurrentListTitle', "")
            this.loadWines()
        } else if (this.playlistId == null) {
            this.$store.commit('updateFilter', {})
            this.$store.commit('updateCurrentListTitle', this.$t('winelist.title'))
            this.loadWines()
        }
    },
    getReloadWines() {
        this.loadWines(true)
    },
},
}
</script>
<style scoped></style>